<section class="pg" id="productos">
  <div class="pg-head">
    <span class="eyebrow">{{ 'productos.eyebrow' | translate }}</span>
    <h1 class="section-title" [innerHTML]="'productos.titleHtml' | translate"></h1>
    <p class="section-lead center">{{ 'productos.lead' | translate }}</p>
  </div>

  <div class="pg-filters">
    <!-- Botones principales -->
    <div class="buttons-container">
      <button *ngFor="let m of mains" [class.active]="main === m.n" (click)="setMain(m.n)">
        {{ m.labelKey | translate }}
      </button>
    </div>
    <!-- Sub-botones -->
    <div class="buttons-container secondary">
      <button *ngFor="let s of secondary" [class.active]="buttonType === s.type" (click)="selectSub(s.type)">
        {{ s.labelKey | translate }}
      </button>
    </div>
  </div>

  <!-- Grid de productos -->
  <div class="images-section">
    <article class="sphere" *ngFor="let p of products"
             [class.img-expand]="isVisible(p)"
             [class.img-shrink]="!isVisible(p)">
      <img [src]="'assets/img/productos/' + p.img" [alt]="p.title">
      <div class="face2">
        <p><strong>{{ p.title }}</strong></p>
        <p [innerHTML]="p.descKey | translate"></p>
        <a [href]="p.url" target="_blank" rel="noopener">{{ 'productos.saberMas' | translate }}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>
        </a>
      </div>
    </article>
  </div>
</section>
